import {Injectable, Injector} from '@angular/core';
import {APlatformAppService} from "@shared/models/platform-app-service-base";
import {Configuration} from '@shared/models/configuration';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceAppService extends APlatformAppService {
  constructor(public injector: Injector) {
    super(injector);
  }
  isEnabled(): boolean {
     return !!Configuration.getConfig('IsWorkspace');
  }
  getLogoAsStyle() {
    return {
      'background-image': `url(https://orbitaxservices.com/orbitax-assets/images/logos/Orbitax-Workspaces.svg)`,
      'width': '165px',
      'height': '18px'
    };
  }
  getToolbarShortcutItems(): any[] {
    const items = super.getToolbarShortcutItems();
    const workspaceItems = items.filter(item => item.key !== 'platform-workspaces');
    return workspaceItems;
  }
}

